import { useEffect, useRef, useState } from "react";
import { Link } from "react-router";
import { useIsSmallScreen } from "./App";
import { NewButton } from "./NewButton";
import { OfficesOfTheDayView } from "./OfficesOfTheDayView";
import { getMorningAndEveningCelebrations } from "./calendar/ordinariate-calendar";
import { HORIZONTAL_RULE_COLOR, RUBRIC_COLOR } from "./tokens";
import { useSettings } from "./utils/settings";

export const NewNewHome = () => {
    const mailRef = useRef<HTMLAnchorElement>(null);

    useEffect(() => {
        if (mailRef.current) {
            mailRef.current.href =
                "mailto:" + ["contact", "singtheoffice.com"].join("@");
        }
    }, []);

    const { settings, setSetting } = useSettings();

    const [date, setDate] = useState(new Date());

    const isEpiphanyTransferred = settings.transferEpiphany === "yes";
    const isAscensionTransferred = settings.transferAscension === "yes";
    const isCorpusChristiTransferred = settings.transferCorpusChristi === "yes";

    const [regionsSwitchedOn, setRegionsSwitchedOn] = useState(
        new Set(localStorage.getItem("region-switches")?.split(";;;"))
    );
    const regionLabelsAllowed: string[] = [];
    regionsSwitchedOn.forEach((r) => regionLabelsAllowed.push(r));

    const year = getMorningAndEveningCelebrations(
        date.getFullYear(),
        isEpiphanyTransferred,
        isAscensionTransferred,
        isCorpusChristiTransferred,
        regionLabelsAllowed
    );

    const todayIndex = year.findIndex(
        (day) =>
            day.date === new Date().getDate() &&
            day.month === new Date().getMonth() + 1 &&
            day.year === new Date().getFullYear()
    );

    const [hour, setHour] = useState<"morning" | "evening">(
        new Date().getHours() > 12 ? "evening" : "morning"
    );

    const partOfYearToShow = year.slice(todayIndex, todayIndex + 9);

    const regionLabelsToShow: Set<string> = new Set();
    partOfYearToShow.forEach((day) => {
        day.regionLabels.forEach((regionLabel) => {
            regionLabelsToShow.add(regionLabel);
        });
    });
    const sortedRegionLabels: string[] = [];
    regionLabelsToShow.forEach((regionLabel) => {
        sortedRegionLabels.push(regionLabel);
    });
    sortedRegionLabels.sort();

    console.log(regionsSwitchedOn);

    return (
        <div>
            <div
                style={{
                    paddingTop: 32,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <div
                    style={{
                        fontSize: "200%",
                        fontWeight: "bold",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        height: 44,
                    }}
                >
                    <div>Sing</div>
                    <div style={{ color: RUBRIC_COLOR }}>The</div>
                    <div>Office</div>
                </div>
                <div
                    style={{
                        color: RUBRIC_COLOR,
                        textAlign: "center",
                        fontWeight: "bold",
                    }}
                >
                    Second Edition
                </div>

                <div
                    style={{
                        textAlign: "center",
                        fontSize: "120%",
                        padding: 24,
                        paddingBottom: 32,
                        maxWidth: 350,
                    }}
                >
                    Daily Offices from the English Prayerbook tradition,
                    pointed&nbsp;for&nbsp;chant.
                </div>
            </div>
            <div style={{ padding: useIsSmallScreen() ? 0 : 8 }}>
                <OfficesOfTheDayView
                    {...partOfYearToShow[0]}
                    isSelected={true}
                    setDate={setDate}
                />
            </div>

            <div style={{ padding: useIsSmallScreen() ? 8 : 16 }}>
                <div
                    style={{
                        border: `1px solid ${HORIZONTAL_RULE_COLOR}`,
                        borderRadius: 4,
                        overflow: "hidden",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "#f4f4f4",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            columnGap: 12,
                            rowGap: 0,
                            justifyContent: "center",
                            padding: 8,
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                                fontSize: "110%",
                            }}
                        >
                            Calendar
                        </div>
                        {[
                            {
                                settingId: "transferEpiphany",
                                requiredLabelToSee: "epiphany",
                                title: "Transfer Epiphany to Sunday",
                            },
                            {
                                settingId: "transferCorpusChristi",
                                requiredLabelToSee: "corpus-christi",
                                title: "Transfer Corpus Christi to Sunday",
                            },
                        ]
                            .filter((transferSetting) => {
                                return (
                                    year
                                        .slice(todayIndex, todayIndex + 15)
                                        .find(
                                            (day) =>
                                                day.morningOptions.find(
                                                    (c) =>
                                                        c.label ===
                                                        transferSetting.requiredLabelToSee
                                                ) !== undefined
                                        ) !== undefined
                                );
                            })
                            .map((transferSetting) => {
                                return (
                                    <div>
                                        <input
                                            type="checkbox"
                                            id={transferSetting.settingId}
                                            checked={
                                                settings[
                                                    transferSetting.settingId
                                                ] === "yes"
                                            }
                                            onClick={() => {
                                                if (
                                                    settings[
                                                        transferSetting
                                                            .settingId
                                                    ] === "yes"
                                                ) {
                                                    setSetting(
                                                        transferSetting.settingId,
                                                        "no"
                                                    );
                                                } else {
                                                    setSetting(
                                                        transferSetting.settingId,
                                                        "yes"
                                                    );
                                                }
                                            }}
                                        />
                                        <label
                                            htmlFor={transferSetting.settingId}
                                            style={{ paddingLeft: 4 }}
                                        >
                                            {transferSetting.title}
                                        </label>
                                    </div>
                                );
                            })}
                        {sortedRegionLabels.map((regionLabel) => {
                            const isOn = regionsSwitchedOn.has(regionLabel);

                            return (
                                <div>
                                    <input
                                        type="checkbox"
                                        id={regionLabel}
                                        checked={isOn}
                                        onClick={() => {
                                            if (isOn) {
                                                regionsSwitchedOn.delete(
                                                    regionLabel
                                                );
                                            } else {
                                                regionsSwitchedOn.add(
                                                    regionLabel
                                                );
                                            }

                                            setRegionsSwitchedOn(
                                                new Set(regionsSwitchedOn)
                                            );

                                            const lsItems: string[] = [];
                                            regionsSwitchedOn.forEach((r) =>
                                                lsItems.push(r)
                                            );

                                            localStorage.setItem(
                                                `region-switches`,
                                                lsItems.join(";;;")
                                            );
                                        }}
                                    />
                                    <label
                                        htmlFor={regionLabel}
                                        style={{ paddingLeft: 4 }}
                                    >
                                        {regionLabel}
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                    {partOfYearToShow.slice(1).map((day) => {
                        const isSelected =
                            day.date === date.getDate() &&
                            day.month === date.getMonth() + 1 &&
                            day.year === date.getFullYear();

                        return (
                            <div
                                style={{
                                    borderTop: `1px solid ${HORIZONTAL_RULE_COLOR}`,
                                }}
                            >
                                <OfficesOfTheDayView
                                    {...day}
                                    setDate={setDate}
                                    isSelected={isSelected}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
            <div
                style={{
                    padding: 24,
                    paddingTop: 8,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                }}
            >
                <Link to="/calendar" style={{ color: "black" }}>
                    <NewButton onClick={() => {}}>Open full calendar</NewButton>
                </Link>
            </div>
            <div
                style={{
                    padding: useIsSmallScreen() ? 8 : 16,
                    paddingTop: 0,
                    paddingBottom: 0,
                }}
            >
                <div
                    style={{
                        textAlign: "left",
                        padding: 24,
                        border: `1px solid ${HORIZONTAL_RULE_COLOR}`,
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                        borderRadius: 4,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "stretch",
                        gap: 12,
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            fontWeight: "bold",
                            textAlign: "center",
                            fontSize: "110%",
                        }}
                    >
                        About
                    </div>
                    <div>
                        SingTheOffice provides Daily Offices from the English
                        Prayerbook tradition, fully pointed for Gregorian Chant,
                        and as of the Second Edition, compliant with the rubrics
                        of Divine Worship: Daily Office (Commonwealth Edition).
                    </div>

                    <div>
                        The first edition of SingTheOffice, with the 1662
                        Calendar, Sarum tones, and other features as released in
                        2021 is still available below.
                    </div>

                    <strong>
                        If you have feedback or suggestions, please{" "}
                        <a type="mailto" ref={mailRef}>
                            get in touch.
                        </a>
                    </strong>

                    <strong>
                        If you would like to receive extremely rare email
                        updates,{" "}
                        <a href="https://singtheoffice.substack.com/subscribe">
                            sign up for our newsletter.
                        </a>
                    </strong>
                </div>
            </div>
            <div
                style={{
                    padding: 24,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                }}
            >
                <Link to="/first-edition" style={{ color: "black" }}>
                    <NewButton onClick={() => {}}>
                        Go to First Edition
                    </NewButton>
                </Link>
            </div>
        </div>
    );
};
